import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ShopifyService } from 'src/app/Services/shopify-service/shopify.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'Authorized-shopify',
    templateUrl: './authorized-shopify.component.html',
    standalone: false
})
export class AuthorizedShopifyComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private shopifyService: ShopifyService,
    private ngxSpinner: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private router: Router,
    private transloco: TranslocoService
  ) { }




  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const hasRequiredParams = params['hmac'] && params['shop'] && params['host'] && params['timestamp'];
      const isCallback = params['code'] || params['state'];
      
      if (hasRequiredParams && !isCallback) {
        this.installFromShopify(params['hmac'], params['shop'], params['host'], params['timestamp']);
      } else {
        
        // ✅ Redirect to embedded app inside Shopify Admin
        
        const fullShop = params['shop']; // e.g. "hamzateam1.myshopify.com"
        const storeName = fullShop?.split('.')[0]; // "hamzateam1"
        const embeddedAppUrl = `https://admin.shopify.com/store/${storeName}/apps/artflowpro`;
        console.log(embeddedAppUrl);
        window.location.href = embeddedAppUrl;
      }
    });
  }


  installFromShopify(hmac: string, shop: string, host: string, timestamp: string): void {
    this.ngxSpinner.show();
    this.shopifyService.onInstallAppFromShopifyPartnerDashboard(hmac, shop, host, timestamp)
      .subscribe(
        (response) => {
          this.ngxSpinner.hide();

          if (response.Success) {
            console.log('Shopify install success:', response);
            
            window.location.href = response.ResponseData;
          } else {
            //Failure - redirect to connect page
            this.router.navigate(['/connect-with-shopify-account']);
          }
        },
        (error) => {
          this.ngxSpinner.hide();
          this.notificationsService.showNotification(
            this.transloco.translate('authorizedShopify.connectionFailed'),
            this.transloco.translate('authorizedShopify.errorInstallingShopifyApp'),
            NotificationTypes.Error
          );
          console.error('Error installing app from Shopify:', error);

          //Also redirect on error
          this.router.navigate(['/connect-with-shopify-account']);
        }
      );
  }

}
